import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/offerings/_layout')({
  component: OfferingsRoot,
});

function OfferingsRoot() {
  return (
    <div className="flex size-full flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
